module.exports = __webpack_public_path__ + "static/media/outlet-profile.3b8f31c8.svg";